"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSchema = exports.AppStatus = exports.DEFENCE_CAMPAIGN_TOKEN = exports.DEFENCE_CAMPAIGN_ID = exports.DIRECT_TEMPLATE_CAMPAIGN_ID = exports.OFFERWALL_TEMPLATE_CAMPAIGN_ID = exports.AlternativeStorageType = exports.AlternativeSourceType = exports.AlternativeOnBackPressed = exports.AlternativeOnActivityResult = exports.AlternativeNetworkTool = exports.AlternativeNavigation = exports.AlternativeLogicType = exports.AlternativeLayoutType = exports.EDirectType = exports.EPlatform = exports.IntegrationVersion = exports.IntegrationType = void 0;
const mongoose_1 = require("mongoose");
// Integration types - OFFERWALL is default
var IntegrationType;
(function (IntegrationType) {
    IntegrationType["OFFERWALL"] = "offerwall";
    IntegrationType["DIRECT"] = "direct";
})(IntegrationType = exports.IntegrationType || (exports.IntegrationType = {}));
// @deprecated - use IntegrationType instead  
var IntegrationVersion;
(function (IntegrationVersion) {
    IntegrationVersion["OFFERWALL"] = "offerwall";
    IntegrationVersion["DIRECT"] = "direct";
    IntegrationVersion["WEB_DIRECT"] = "web_direct";
    IntegrationVersion["NONE"] = "none";
    IntegrationVersion["POLICY"] = "policy";
    IntegrationVersion["OFFER_STUB"] = "offer_stub";
    IntegrationVersion["WEB"] = "web";
    IntegrationVersion["BANNER"] = "banner";
    IntegrationVersion["PWA"] = "pwa";
})(IntegrationVersion = exports.IntegrationVersion || (exports.IntegrationVersion = {}));
// @deprecated - Platform enum (no longer used)
var EPlatform;
(function (EPlatform) {
    EPlatform["GENERAL"] = "@";
    EPlatform["SAMSUNG"] = "samsung";
})(EPlatform = exports.EPlatform || (exports.EPlatform = {}));
// @deprecated - Direct type enum
var EDirectType;
(function (EDirectType) {
    EDirectType["ELTRAFICO"] = "eltrafico";
    EDirectType["TRAFFLE"] = "traffle";
    EDirectType["KEITARO_OFFER"] = "keitaro_offer";
    EDirectType["OFFER_DIRECT"] = "offer_direct";
})(EDirectType = exports.EDirectType || (exports.EDirectType = {}));
// @deprecated - Constructor types
var AlternativeLayoutType;
(function (AlternativeLayoutType) {
    AlternativeLayoutType["DEFAULT"] = "default";
})(AlternativeLayoutType = exports.AlternativeLayoutType || (exports.AlternativeLayoutType = {}));
var AlternativeLogicType;
(function (AlternativeLogicType) {
    AlternativeLogicType["DEFAULT"] = "default";
})(AlternativeLogicType = exports.AlternativeLogicType || (exports.AlternativeLogicType = {}));
var AlternativeNavigation;
(function (AlternativeNavigation) {
    AlternativeNavigation["DEFAULT"] = "default";
})(AlternativeNavigation = exports.AlternativeNavigation || (exports.AlternativeNavigation = {}));
var AlternativeNetworkTool;
(function (AlternativeNetworkTool) {
    AlternativeNetworkTool["DEFAULT"] = "default";
})(AlternativeNetworkTool = exports.AlternativeNetworkTool || (exports.AlternativeNetworkTool = {}));
var AlternativeOnActivityResult;
(function (AlternativeOnActivityResult) {
    AlternativeOnActivityResult["DEFAULT"] = "default";
})(AlternativeOnActivityResult = exports.AlternativeOnActivityResult || (exports.AlternativeOnActivityResult = {}));
var AlternativeOnBackPressed;
(function (AlternativeOnBackPressed) {
    AlternativeOnBackPressed["DEFAULT"] = "default";
})(AlternativeOnBackPressed = exports.AlternativeOnBackPressed || (exports.AlternativeOnBackPressed = {}));
var AlternativeSourceType;
(function (AlternativeSourceType) {
    AlternativeSourceType["DEFAULT"] = "default";
})(AlternativeSourceType = exports.AlternativeSourceType || (exports.AlternativeSourceType = {}));
var AlternativeStorageType;
(function (AlternativeStorageType) {
    AlternativeStorageType["DEFAULT"] = "default";
})(AlternativeStorageType = exports.AlternativeStorageType || (exports.AlternativeStorageType = {}));
// Campaign IDs for cloning
exports.OFFERWALL_TEMPLATE_CAMPAIGN_ID = 3497;
exports.DIRECT_TEMPLATE_CAMPAIGN_ID = 3499;
exports.DEFENCE_CAMPAIGN_ID = 3498;
exports.DEFENCE_CAMPAIGN_TOKEN = 'hnwtbnwvq5lrvmztxnc78gxgxtk24jq8';
var AppStatus;
(function (AppStatus) {
    AppStatus["ARCHIVED"] = "ARCHIVED";
    AppStatus["IN_DEVELOPMENT"] = "IN_DEVELOPMENT";
    AppStatus["READY"] = "READY";
    AppStatus["DISABLED"] = "DISABLED";
})(AppStatus = exports.AppStatus || (exports.AppStatus = {}));
exports.AppSchema = new mongoose_1.Schema({
    id: {
        type: Number,
        unique: true,
        required: true
    },
    enabled: {
        type: Boolean,
        required: true,
        default: false
    },
    status: {
        type: String,
        enum: AppStatus,
        default: AppStatus.IN_DEVELOPMENT
    },
    integrationType: {
        type: String,
        enum: IntegrationType,
        default: IntegrationType.OFFERWALL
    },
    bundle: {
        type: String,
        unique: true,
        required: true
    },
    name: String,
    onesignalAppId: {
        type: String,
        required: false
    },
    onesignalRestApiKey: {
        type: String,
        required: false
    },
    offerwallCampaign: {
        trackingCampaignId: Number,
        trackingCampaignName: String,
        trackingCampaignAlias: String,
        trackingDomainId: Number,
        trackingDomainName: String,
        campingToken: String,
        trackingParams: {
            naming: String,
            firebase_app_instance_id: String,
            firebase_user_id: String,
            firebase_device_language_code: String,
            firebase_push_token: String,
            bundle_id: String,
            advertising_id: String,
            appsflyer_device_id: String,
            campaign: String
        }
    },
    directCampaign: {
        trackingCampaignId: Number,
        trackingCampaignName: String,
        trackingCampaignAlias: String,
        trackingDomainId: Number,
        trackingDomainName: String,
        campingToken: String,
        trackingParams: {
            naming: String,
            firebase_app_instance_id: String,
            firebase_user_id: String,
            firebase_device_language_code: String,
            firebase_push_token: String,
            bundle_id: String,
            advertising_id: String,
            appsflyer_device_id: String,
            campaign: String
        }
    },
    appsflyerParams: {
        apiToken: String,
        eventIds: Object,
        appId: String,
        devKey: String
    },
    domainParams: {
        name: {
            type: String,
            unique: true
        },
        clouflareZone: String,
        ready: Boolean
    },
    policyPath: {
        type: String,
        default: "none"
    },
    postbacks: [{
            campaign_id: {
                type: Number,
                required: true
            },
            id: {
                type: Number,
                required: true
            },
            method: {
                type: String,
                enum: ["GET", "POST"],
                required: true
            },
            statuses: [{
                    type: String,
                    required: true
                }],
            url: {
                type: String,
                required: true
            },
            notes: {
                type: String,
                required: false
            }
        }],
    // @deprecated fields for backwards compatibility
    keitaroData: {
        trackingCampaignId: Number,
        trackingCampaignName: String,
        trackingCampaignAlias: String,
        trackingDomainId: Number,
        trackingDomainName: String,
        campingToken: String,
        trackingParams: mongoose_1.Schema.Types.Mixed
    },
    platforms: mongoose_1.Schema.Types.Mixed,
    bannerParams: mongoose_1.Schema.Types.Mixed,
    offersStubParams: mongoose_1.Schema.Types.Mixed,
    ech: mongoose_1.Schema.Types.Mixed,
    offerwallParams: mongoose_1.Schema.Types.Mixed,
    appmetricaApiKey: String,
    appmetricaAppId: String
});
